export enum LOCAL_STORAGE_KEYS {
	HAS_ALIASED_MIXPANEL_USER = 'has-aliased-mixpanel-user',
	LAST_USED_IMPORT_DATA = 'LAST_USED_IMPORT_DATA',
	VIDEO_PLAYBACK_SPEED = 'video-playback-speed',
	PLAYGROUND_FORM_DATA = 'playground-form-data',
	AI_ASSISTANT_PAUSED_QUERIES = 'ai_assistant_paused_queries',
	SCHEDULING_MODAL_DRAFTS = 'scheduling-modal-drafts',
	AGENT_LAST_CHAT_PER_WORKSPACE = 'agent-last-chat-per-workspace',
	AGENT_INPUT_DRAFT_PER_WORKSPACE = 'agent-input-draft-per-workspace',
	AGENT_DOCK_WIDTH = 'agent-dock-width',
	AGENT_PANEL_OPEN = 'agent-panel-open',
	FOCUSED_AI_LAYOUT_SPLIT_PERCENT = 'focused-ai-layout-split-percent',
	FORM_FILL_DRAFTS = 'form-fill-drafts',
	LAST_USED_IMPORT_SUBMISSIONS_DATA = 'LAST_USED_IMPORT_SUBMISSIONS_DATA',
	CHANGELOG_CARD_DISMISSED = 'changelog-card-dismissed',
	MCP_ACCESS_REQUESTED_PER_WORKSPACE = 'mcp-access-requested-per-workspace',
}

export enum SESSION_STORAGE_KEYS {
	IS_USER_CREATED_VIA_ONBOARDING = 'created-via-onboarding',
	PENDING_PLAYGROUND_PUBLISH = 'pending-playground-publish',
	AGENT_REOPEN_PANEL = 'agent-reopen-panel',
	AGENT_KEEP_RESUME = 'agent-keep-resume',
	AGENT_PARKED_SUBMISSION = 'agent-parked-submission',
	PENDING_TABLE_FILTERS = 'pending-table-filters',
	FEEDBACK_DRAFTS = 'feedback-drafts',
}
